import { classNames } from '@progress/kendo-react-common';
import { DisputeStatus } from 'enums';
import styles from './DisputeStatusBadge.module.scss';

const BadgeLabels = {
    [DisputeStatus.Received]: 'RECEIVED',
    [DisputeStatus.InReview]: 'IN REVIEW',
    [DisputeStatus.Closed]: 'CLOSED',
    [DisputeStatus.VendorReview]: 'ACTION REQUIRED',
    [DisputeStatus.FinalReview]: 'FINAL REVIEW',
};

type DisputeStatusBadgeProps = {
    status: DisputeStatus
};

const DisputeStatusBadge = ({ status }: DisputeStatusBadgeProps) => (
    <div className={classNames(styles.badge , {
        [styles.received]: status === DisputeStatus.Received,
        [styles.inReview]: status === DisputeStatus.InReview,
        [styles.closed]: status === DisputeStatus.Closed,
        [styles.vendorReview]: status === DisputeStatus.VendorReview,
        [styles.finalReview]: status === DisputeStatus.FinalReview,
    })}>
        {BadgeLabels[status as keyof typeof BadgeLabels] ?? 'Not Found'}
    </div>
);

export default DisputeStatusBadge;